import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Headers, Response } from "@angular/http";
import { Observable } from "rxjs/Observable"
import { AuthHttp } from 'angular2-jwt';

import "rxjs/add/operator/map";

@Injectable()
export class BonusTemplateApiService {

  constructor(
    private http: Http,
    private authHttp: AuthHttp
  ) { }

  GetAllBonusTemplates() {
    return this.authHttp.get(environment.apiEndPoint + '/bonustemplate/template').map((response: Response) => response.json());
  }

  GetBonusTemplate(templateID) {
    return this.authHttp.get(environment.apiEndPoint + '/bonustemplate/template/' + templateID).map((response: Response) => response.json());
  }

  GetExcelData(templateID) {
    return this.authHttp.get(environment.apiEndPoint + '/bonustemplate/excel/' + templateID).map((response: Response) => response.json());
  }

  GetMappingData() {
    return this.authHttp.get(environment.apiEndPoint + '/bonustemplate/mappingsource').map((response: Response) => response.json());
  }

  SaveBonusTemplate(templateName) {
    var formData = new FormData();
    formData.append('TemplateName', templateName);

    return this.authHttp.post(environment.apiEndPoint + '/bonustemplate/template', formData).map((response: Response) => response.json());
  }

  DeleteBonusTemplate(templateID, timeStatus) {
    var formData = new FormData();
    formData.append("timestatus", timeStatus);
    return this.authHttp.post(environment.apiEndPoint + '/bonustemplate/template/' + templateID, formData).map((response: Response) => response.json());
  }

  SaveBonusTemplateDetail(data) {
    var formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    return this.authHttp.post(environment.apiEndPoint + '/bonustemplate/templatedetail', formData).map((response: Response) => response.json());
  }

  SaveBonusTemplateMapping(original, modified) {
    var headers = new Headers({
      'Content-Type': 'application/json'
    });
    var data = {
      originalList: original,
      modifiedList: modified
    }
    return this.authHttp.post(environment.apiEndPoint + '/bonustemplate/mappingdetail', JSON.stringify(data), { headers: headers }).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/BonusTemplateApi.service.ts